import { TableActions } from "../../../components/tables/tableContext/TableContext";
import TableWidget from "../../../components/tables/TableWidget";
import { getReturningProductsToProviderRaports } from "../../../redux/api/reports.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { dateForDatabase } from "../../../utils/dateAndTime";
import ReturningProductsReportsTableHeader from "./components/ReturningProductsReportsTableHeader";
import ReturningProductsReportsActionButton from "./TableActionButtonsComponents/ReturningProductsReportsActionButton";
import {
  getReturningProductsToProviderReportsTableData,
  returningProductsToProviderReportsTableHeader,
} from "./tableConfigs/returningProductsToProviderReportsTableConfig";

function ReturningProductsReports() {
  const dispatch = useAppDispatch();
  const {
    reports: {
      returningProductsToProvider: {
        data: { data: returningProductsToProviderList, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      const formatDate: string = dateForDatabase(action.tableSearch.dataPV);

      dispatch(
        getReturningProductsToProviderRaports({
          page: action.tablePagination.page,
          per_page: action.tablePagination.rowsPerPage,
          user: action.tableSearch.user,
          provider: action.tableSearch.provider,
          dataPV: formatDate,
          docNrAndDate: action.tableSearch.docNrAndDate,
          productName: action.tableSearch.productName,
          lot: action.tableSearch.lot,
          tipPv: action.tableSearch.tipPv,
        }),
      );
    }
  };

  const sortedReturningProductsToProviderList = [
    ...returningProductsToProviderList,
  ].sort((a, b) => {
    if (a.nr_raport > b.nr_raport) {
      return -1;
    }
    if (a.nr_raport < b.nr_raport) {
      return 1;
    }
    return 0;
  });

  return (
    <TableWidget
      CustomHeaderComponent={ReturningProductsReportsTableHeader}
      tableHeaderData={returningProductsToProviderReportsTableHeader}
      tableItemsData={getReturningProductsToProviderReportsTableData(
        sortedReturningProductsToProviderList,
      )}
      totalItems={total}
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
      ActionButtonsComponent={(props: any) => (
        <ReturningProductsReportsActionButton {...props} />
      )}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default ReturningProductsReports;
